// import { useEffect } from "react";
// import { useHistory } from "react-router-dom";
// import useLoginOps from "../hooks/useLoginOps";

// export default function SamlAutoLogin(props) {
//     const history = useHistory();
//     const loginOps = useLoginOps(props);

//     useEffect(() => {
//         const run = async () => {
//             const userId = window.location.pathname.split("/")[2];

//             if (!/^[0-9a-fA-F]{24}$/.test(userId)) {
//                 history.replace("/login");
//                 return;
//             }

//             try {
//                 const res = await fetch(
//                     "https://aiconnect.cc:35878/restapi/verifySamlToken",
//                     {
//                         method: "POST",
//                         headers: { "Content-Type": "application/json" },
//                         body: JSON.stringify({ id: userId })
//                     }
//                 );

//                 if (!res.ok) throw new Error();

//                 const data = await res.json();

//                 if (data?.user?.token) {
//                     await loginOps.handleSamlLogin(data.user);
//                     history.replace("/dashboard");
//                 } else {
//                     history.replace("/login");
//                 }
//             } catch {
//                 history.replace("/login");
//             }
//         };

//         run();
//     }, []);

//     return null; // ✅ NO UI → NO BLINK
// }





// import React, { useEffect } from "react";
// import { useHistory } from "react-router-dom";
// import useLoginOps from "../hooks/useLoginOps";

// export default function SamlAutoLogin(props) {
//     const history = useHistory();
//     const loginOps = useLoginOps(props);

//     useEffect(() => {
//         const run = async () => {
//             const userId = window.location.pathname.split("/")[2];

//             if (!/^[0-9a-fA-F]{24}$/.test(userId)) {
//                 history.replace("/login");
//                 return;
//             }

//             try {
//                 const res = await fetch(
//                     "https://aiconnect.cc:35878/restapi/verifySamlToken",
//                     {
//                         method: "POST",
//                         headers: { "Content-Type": "application/json" },
//                         body: JSON.stringify({ id: userId })
//                     }
//                 );

//                 if (!res.ok) throw new Error();

//                 const data = await res.json();

//                 // if (data?.user?.token) {
//                 //     await loginOps.handleSamlLogin(data.user);
//                 //     history.replace("/dashboard");
//                 // } 
//                 if (data?.user?.token) {
//     await loginOps.handleSamlLogin(data.user);

//     // silently add dashboard to history
//     history.push("/dashboard");

//     // land user on tinkerorbit
//     history.push("/activity");
// }

                
//                 else {
//                     history.replace("/login");
//                 }
//             } catch {
//                 history.replace("/login");
//             }
//         };

//         run();
//     }, []);

//     /* 🔹 Minimal fallback UI (NO LOGIN UI, NO BLINK) */
//     return (
//         <div
//             style={{
//                 height: "100vh",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 backgroundColor: "#ffffff"
//             }}
//         >
//             <div
//                 style={{
//                     width: "40px",
//                     height: "40px",
//                     border: "4px solid #e0e0e0",
//                     borderTop: "4px solid #1976d2",
//                     borderRadius: "50%",
//                     animation: "spin 1s linear infinite"
//                 }}
//             />
//             <p style={{ marginTop: "16px", fontSize: "14px", color: "#555" }}>
//                 Please wait, logging you in…
//             </p>

//             {/* Inline keyframes to avoid CSS dependency */}
//             <style>
//                 {`
//                     @keyframes spin {
//                         0% { transform: rotate(0deg); }
//                         100% { transform: rotate(360deg); }
//                     }
//                 `}
//             </style>
//         </div>
//     );
// }

// // SamlAutoLogin.js   working 
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useLoginOps from "../hooks/useLoginOps";

export default function SamlAutoLogin(props) {
    const history = useHistory();
    const loginOps = useLoginOps(props);

    useEffect(() => {
        const run = async () => {
            const userId = window.location.pathname.split("/")[2];

            if (!/^[0-9a-fA-F]{24}$/.test(userId)) {
                history.replace("/login");
                return;
            }

            try {
                const res = await fetch(
                    "https://staging.aiconnect.cc:35878/restapi/verifySamlToken",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: userId })
                    }
                );

                if (!res.ok) throw new Error();
                const data = await res.json();

                if (data?.user?.token) {
                    await loginOps.handleSamlLogin(data.user);

                    // 🔐 mark dashboard as visited
                    sessionStorage.setItem("passedDashboard", "1");

                    // ✅ must go dashboard first
                    history.push("/dashboard");

                    // small delay is intentional
                    setTimeout(() => {
                        history.push("/activity");
                    }, 400);

                } else {
                    history.replace("/login");
                }
            } catch {
                history.replace("/login");
            }
        };

        run();
    }, []);

    return (
         <div
            style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#ffffff"
            }}
        >
            <div
                style={{
                    width: "40px",
                    height: "40px",
                    border: "4px solid #e0e0e0",
                    borderTop: "4px solid #1976d2",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite"
                }}
            />
            <p style={{ marginTop: "16px", fontSize: "14px", color: "#555" }}>
                Please wait, logging you in…
            </p>

            {/* Inline keyframes to avoid CSS dependency */}
            <style>
                {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
            </style>
        </div>
    );
}






// 2Nd Working

// import React, { useEffect, useState, useRef } from "react";
// import { useHistory } from "react-router-dom";
// import useLoginOps from "../hooks/useLoginOps";

// export default function SamlAutoLogin(props) {
//     const history = useHistory();
//     const loginOps = useLoginOps(props);
//     const [status, setStatus] = useState("Verifying login...");
//     const hasProcessed = useRef(false);

//     useEffect(() => {
//         if (hasProcessed.current) return;
//         hasProcessed.current = true;

//         const run = async () => {
//             const userId = window.location.pathname.split("/")[2];

//             if (!/^[0-9a-fA-F]{24}$/.test(userId)) {
//                 history.replace("/login");
//                 return;
//             }

//             try {
//                 setStatus("Verifying SAML token...");
//                 const res = await fetch(
//                     "https://staging.aiconnect.cc:35878/restapi/verifySamlToken",
//                     {
//                         method: "POST",
//                         headers: { "Content-Type": "application/json" },
//                         body: JSON.stringify({ id: userId })
//                     }
//                 );

//                 if (!res.ok) throw new Error("Token verification failed");
//                 const data = await res.json();

//                 if (data?.user?.token) {
//                     // Perform SAML login first
//                     await loginOps.handleSamlLogin(data.user);
                    
//                     // 🔐 mark dashboard as visited
//                     sessionStorage.setItem("passedDashboard", "1");

//                     // Check if user has projects
//                     const hasProjects = await checkUserProjects(data.user);
                    
//                     if (!hasProjects) {
//                         // If no projects, set flag to auto-create TC activity
//                         localStorage.setItem("samlAutoCreateTC", "true");
//                     }
                    
//                     // Redirect to dashboard
//                     history.push("/dashboard");
                    
//                 } else {
//                     history.replace("/login");
//                 }
//             } catch (error) {
//                 console.error("SAML login error:", error);
//                 history.replace("/login");
//             }
//         };

//         const checkUserProjects = async (userData) => {
//             try {
//                 setStatus("Checking your projects...");
                
//                 // Get authorization token
//                 const authToken = userData.token;
                
//                 if (!authToken) {
//                     return false;
//                 }

//                 // Check if projects exist
//                 const checkRes = await fetch(
//                     "https://staging.aiconnect.cc:35878/restapi/getUserDocKeyValue",
//                     {
//                         method: "POST",
//                         headers: { 
//                             "Content-Type": "application/json",
//                             "Authorization": `Bearer ${authToken}`,
//                             "useremailid": userData.email
//                         },
//                         body: JSON.stringify({ key: "projects" })
//                     }
//                 );
                
//                 if (checkRes.ok) {
//                     const projectsData = await checkRes.json();
//                     return projectsData?.content && projectsData.content.length > 0;
//                 }
                
//                 return false;
                
//             } catch (error) {
//                 console.error("Project check error:", error);
//                 return false;
//             }
//         };

//         run();

//         return () => {
//             // Cleanup if needed
//         };
//     }, [history, loginOps]);

//     return (
//         <div
//             style={{
//                 height: "100vh",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 backgroundColor: "#ffffff"
//             }}
//         >
//             <div
//                 style={{
//                     width: "40px",
//                     height: "40px",
//                     border: "4px solid #e0e0e0",
//                     borderTop: "4px solid #1976d2",
//                     borderRadius: "50%",
//                     animation: "spin 1s linear infinite"
//                 }}
//             />
//             <p style={{ 
//                 marginTop: "16px", 
//                 fontSize: "14px", 
//                 color: "#555",
//                 textAlign: "center",
//                 maxWidth: "300px",
//                 padding: "0 20px"
//             }}>
//                 {status}
//             </p>

//             <style>
//                 {`
//                     @keyframes spin {
//                         0% { transform: rotate(0deg); }
//                         100% { transform: rotate(360deg); }
//                     }
//                 `}
//             </style>
//         </div>
//     );
// }











// SamlAutoLogin.js
// import React, { useEffect } from "react";
// import { useHistory } from "react-router-dom";
// import useLoginOps from "../hooks/useLoginOps";
// import { appData } from "../util/appData"; // ensure appData is imported

// export default function SamlAutoLogin(props) {
//     const history = useHistory();
//     const loginOps = useLoginOps(props);

//     useEffect(() => {
//         const run = async () => {
//             const userId = window.location.pathname.split("/")[2];

//             if (!/^[0-9a-fA-F]{24}$/.test(userId)) {
//                 history.replace("/login");
//                 return;
//             }

//             try {
//                 const res = await fetch(
//                     "https://staging.aiconnect.cc:35878/restapi/verifySamlToken",
//                     {
//                         method: "POST",
//                         headers: { "Content-Type": "application/json" },
//                         body: JSON.stringify({ id: userId })
//                     }
//                 );

//                 if (!res.ok) throw new Error();
//                 const data = await res.json();

//                 if (data?.user?.token) {
//                     await loginOps.handleSamlLogin(data.user);

//                     sessionStorage.setItem("passedDashboard", "1");

//                     // --- Select Tinker Orbits (3rd card) ---
//                     const activityType = "TC"; // Tinker Orbits
//                     const time = new Date().getTime();

//                     const tinkerOrbitsActivity = {
//                         activity_type: activityType,
//                         creation_date: "" + time,
//                         last_modified_date: "" + time
//                     };

//                     // Use default content from appData to avoid null errors
//                     const tinkerOrbitsContent = {
//                         ...appData.defaultNetworkResponses.defaultCustomActivityContent.types[activityType],
//                         activityMetadata: tinkerOrbitsActivity
//                     };

//                     props.set_userSelectedActivity(tinkerOrbitsActivity);
//                     props.set_userSelectedActivityContent(tinkerOrbitsContent);

//                     // Go directly to activity page
//                     history.replace("/activity");

//                     // Automatically click Tinker Orbits button if exists
//                     const triggerTCButton = () => {
//                         const btn = document.getElementById("create_tc");
//                         if (btn) {
//                             btn.click();
//                         } else {
//                             setTimeout(triggerTCButton, 100);
//                         }
//                     };

//                     triggerTCButton();

//                 } else {
//                     history.replace("/login");
//                 }
//             } catch {
//                 history.replace("/login");
//             }
//         };

//         run();
//     }, []);

//     return (
//         <div
//             style={{
//                 height: "100vh",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 backgroundColor: "#ffffff"
//             }}
//         >
//             <div
//                 style={{
//                     width: "40px",
//                     height: "40px",
//                     border: "4px solid #e0e0e0",
//                     borderTop: "4px solid #1976d2",
//                     borderRadius: "50%",
//                     animation: "spin 1s linear infinite"
//                 }}
//             />
//             <p style={{ marginTop: "16px", fontSize: "14px", color: "#555" }}>
//                 Please wait, logging you in…
//             </p>

//             <style>
//                 {`
//                     @keyframes spin {
//                         0% { transform: rotate(0deg); }
//                         100% { transform: rotate(360deg); }
//                     }
//                 `}
//             </style>
//         </div>
//     );
// }





